import { useRef, useEffect } from "react";
import { Slide, Card, CardHeader, CardContent, IconButton, CardActions, Button } from "@mui/material";
import { ExpandMore, MoreHoriz, SendRounded, ThumbDownAltRounded, ThumbUpAltRounded, WhatsApp } from "@mui/icons-material";
import { historyItem, feedbackModalProps } from "./index";
import Form from "components/Form";
import TextField from "components/TextField";
import icon from "./icon.png";

function ChatBox({
  history,
  isChatOpen,
  isLoading,
  onSubmitQuestion,
  onOpenFeedbackModal,
  onClose,
}:
{
  history: historyItem[];
  isChatOpen: boolean;
  isLoading: boolean;
  onSubmitQuestion: (question: string) => void;
  onOpenFeedbackModal: (props: feedbackModalProps) => void;
  onClose: () => void;
}){

  const formRef =  useRef<HTMLFormElement>(null);

  const isDefaultResponse = (response: string) => {
    return response.startsWith("Ainda não tenho essa resposta no meu repertório");
  };

  useEffect(() => {
    if(history.length > 0){
      const lastDiv = document.querySelector(".chat div:last-child");
      lastDiv!.scrollIntoView({ behavior: "smooth" });
    };
  },[history]);

  return (
    <Slide direction="up" in={isChatOpen}>
      <Card 
        sx={{
          width: { md: 450, xs: '95%' },
          position: 'fixed',
          bottom: 0,
          right: { md: 25, xs: 0 },
          left: { md: 'auto', xs: 0 },
          margin: { xs: '0 auto', md: 0 },
          zIndex: 9999,
        }}
        elevation={4}
      >
        <CardHeader avatar={<img alt="Avatar SIG" src={icon} />} action={<IconButton onClick={onClose} size="small" sx={{ color: 'white' }}><ExpandMore/></IconButton>} title={'SIG - Assistente Virtual'} sx={{ bgcolor: '#006666', color: '#fff' }}>
          SIG - Assistente Virtual
        </CardHeader>
        <CardContent
          id="chat"
          sx={{ height: {md: 450, xs: '80vh'}, minHeight:'80%', overflowY: 'scroll' }}
        >
          <div className="chat">
            <div className={'msg rcvd'}>
              Sou a SIG, assistente virtual do SIGA.<br/>
              Me conta, como posso te ajudar? 😊.<br/>
            </div>
            {history.map(({ content, role, time, responseId, feedback }: historyItem, i: number) => 
              <div key={i} data-time={time} className={`msg ${role === 'user' ? 'sent' : 'rcvd'}`}>
                {content}
                {isDefaultResponse(content)
                  ? <Button
                      sx={{ my: 2 }}
                      endIcon={<WhatsApp />}
                      variant='outlined'
                      target="_blank"
                      rel="noreferrer"
                      href={'https://wa.me/553195283733'}
                    >
                      Fale conosco Via Whatsapp
                    </Button>
                  : role === 'assistant' &&
                    <>
                      <IconButton onClick={() => {
                        onOpenFeedbackModal({
                          isOpen: true,
                          idconsulta: responseId,
                          pergunta: history[history.length - 2].content,
                          resposta: content,
                          avaliacao: true,
                        });
                      }}>
                        <ThumbUpAltRounded sx={{ color: feedback ? '#006666' : 'inherit' }}/>
                      </IconButton>
                      <IconButton onClick={() => {
                        onOpenFeedbackModal({
                          isOpen: true,
                          idconsulta: responseId,
                          pergunta: history[history.length - 2].content,
                          resposta: content,
                          avaliacao: false
                        });
                      }}>
                        <ThumbDownAltRounded sx={{ color: feedback === false ? '#006666' : 'inherit' }}/>
                      </IconButton>
                    </>
                  }
              </div>
            )}
            {isLoading &&
              <div className={'msg rcvd'}><MoreHoriz/></div>
            }
          </div>
        </CardContent>
        <CardActions>
          <Form
            sx={{ width: '100%' }}
            onSubmit={({ question }: { question: string  }) => {
              if(!question) return;
              onSubmitQuestion(question);
              formRef.current!.value = "";
            }}
          >
            <TextField
              inputRef={formRef}
              label={"Qual a sua dúvida?"}
              name={"question"}
              fullWidth
              InputProps={{
                endAdornment:
                  <IconButton type='submit'>
                    <SendRounded/>
                  </IconButton>
              }}
            />
          </Form>
        </CardActions>
      </Card>
    </Slide>
  );
};
export default ChatBox;